export const customState: CustomState = {
    currentOrganizationId: undefined,
    instanceId: undefined,
    appRestApiName: undefined,
    appServiceId: undefined,
    bridgeRestApiName: undefined,
    selectedEntityParentRecordId: undefined,
    selectedEntityUId: undefined,
};

export interface CustomState {
    currentOrganizationId: string;
    instanceId: string;
    appRestApiName: string;
    appServiceId: string;
    bridgeRestApiName: string;
    selectedEntityParentRecordId: string;
    selectedEntityUId: string;
}
